import { Button } from 'react-bootstrap';

import SelectMulti from 'app/components/Select/SelectMulti';
import Typography from 'app/components/Typography';

import { Body, Header, Main } from 'app/modules/inventory/stock-run/components/StockRunFilter';
import {
  ORGANIZATION_OPTIONS,
  RECIPIENT_TYPE_OPTIONS,
  SELECTED_ORGANIZATION,
  SELECTED_RECIPIENT_TYPE,
  SELECTED_TYPE,
  TYPE_OPTIONS,
} from 'app/modules/mail-history/core/constants';
import useMailHistoryFilter from 'app/modules/mail-history/hooks/useMailHistoryFilter';

import { useOrganizationStore } from 'theme/layout/components/aside/store';

interface MailHistoryFilterProps {
  openFilter: boolean;
  setIsOpenFilter: React.Dispatch<
    React.SetStateAction<{
      content: boolean;
      recipient: boolean;
      filter: boolean;
    }>
  >;
}

const MailHistoryFilter = ({ openFilter, setIsOpenFilter }: MailHistoryFilterProps) => {
  const organizations = useOrganizationStore((store) => store.state.organizationList);

  const {
    filter,
    menuIsOpen,
    handleClearAll,
    handleMenuOpen,
    handleMenuClose,
    handleSelectChange,
    handleApplyFilter,
  } = useMailHistoryFilter(openFilter, setIsOpenFilter);

  return (
    <Main>
      <Header>
        <Typography variant="heading-6">Filter</Typography>
        <Typography
          className="clear_all cursor-pointer"
          variant="body-5"
          onClick={handleClearAll}
          color="primary"
        >
          Clear all
        </Typography>
      </Header>
      <Body>
        <Typography variant="body-7" color="gray-700" className="mb-2">
          Organization
        </Typography>
        <SelectMulti
          options={ORGANIZATION_OPTIONS(organizations) ?? []}
          selectedOption={SELECTED_ORGANIZATION(filter.organizationId ?? [], organizations)}
          handleChange={handleSelectChange('organizationId')}
          placeholder="Select organization to filter"
          menuIsOpen={menuIsOpen.organization}
          onMenuClose={handleMenuClose('organization')}
          openMenuOnClick={handleMenuOpen('organization')}
        />
        <div className="mt-4">
          <Typography variant="body-7" color="gray-700" className="mb-2">
            Type
          </Typography>
          <SelectMulti
            options={TYPE_OPTIONS}
            selectedOption={SELECTED_TYPE(filter.type ?? [])}
            handleChange={handleSelectChange('type')}
            placeholder="Select type to filter"
            menuIsOpen={menuIsOpen.type}
            onMenuClose={handleMenuClose('type')}
            openMenuOnClick={handleMenuOpen('type')}
          />
        </div>

        <div className="mt-4">
          <Typography variant="body-7" color="gray-700" className="mb-2">
            Recipient type
          </Typography>
          <SelectMulti
            options={RECIPIENT_TYPE_OPTIONS}
            selectedOption={SELECTED_RECIPIENT_TYPE(filter.recipientType ?? [])}
            handleChange={handleSelectChange('recipientType')}
            placeholder="Select recipient type to filter"
            menuIsOpen={menuIsOpen.recipientType}
            onMenuClose={handleMenuClose('recipientType')}
            openMenuOnClick={handleMenuOpen('recipientType')}
          />
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button variant="primary" onClick={handleApplyFilter}>
            Apply
          </Button>
        </div>
      </Body>
    </Main>
  );
};

export default MailHistoryFilter;
